<template>
	<div
		class="ms-grid-viewer ms-editor"
		:class="{ selectedTextMode: selectedTextMode, 'h-auto': maxHeight }"
		v-if="!useVirtualScroll"
		@keydown="keyDownGrid"
		ref="msgridEditorv3"
	>
		<div
			class="ms-content--header"
			ref="header"
			:class="{
				'hide-scroll': scrollVisiable && !greyTitle,
				'hide-scroll-grey': scrollVisiable && greyTitle,
			}"
		>
			<div class="ms-thead-v3" ref="msTheadV3">
				<th
					class="ms-th"
					v-for="(col, index) in listGroupColumns"
					:key="index"
					:style="calculateWidthGroup(col, index, listGroupColumns)"
				>
					{{ col.title }}
					<div v-if="col.isAva" :class="col.iconAVA"></div>
				</th>
			</div>
			<table class="ms-table">
				<thead class="ms-thead" ref="msThead">
					<tr class="ms-tr">
						<th
							class="ms-th serial-title"
							v-if="serial"
							:class="{ 'grey-title': greyTitle }"
						>
							{{ $t('i18nCommon.OrderNumber') }}
						</th>
						<th v-if="multiple" class="ms-th multiple-cell">
							<ms-checkbox
								:value="isCheckedMultiple"
								@click="changeCheckedMultiple"
								class="justify-center"
								checkOnly
							/>
						</th>
						<ms-th
							ref="th"
							class="ms-th"
							v-for="(col, colIndex) in columnx"
							:style="
								col.backgroundColor
									? `backgroundColor:${col.backgroundColor}`
									: ''
							"
							:key="col.dataField"
							:col="col"
							:class="[
								{ 'grey-title': greyTitle },
								columnx && colIndex == columnx.length - 1
									? 'ms-th-last-col'
									: '',
							]"
							@resizeOn="resizeActive"
							@resizeOff="resizeClose"
						></ms-th>
					</tr>
				</thead>
			</table>
		</div>
		<div
			ref="content"
			class="ms-content--table"
			@scroll="onScroll"
			:style="gridViewStyle"
		>
			<table class="ms-table">
				<tbody class="ms-tbody" v-if="datax && datax.length > 0">
					<ms-tr-v-3
						v-for="(dataRow, indexRow) in datax"
						:key="dataRow['__vKeyValue']"
						:ref="`tr-${indexRow}`"
						:columns="columnx"
						:dataRow="dataRow"
						:rowIndex="indexRow"
						:isSelected="isSelected(dataRow)"
						:widgetOptions="widgetOptions"
						:rowSelected="rowSelected"
						:multiple="multiple"
						:serial="serial"
						v-on="listeners"
						:editable="editable"
						:class="[
							{ 'row-editor': dataRow == rowSelected },
							datax && indexRow == datax.length - 1 ? 'ms-tr-last' : '',
						]"
						:isHoverTr="isHoverTr"
						@click="cellClick"
						:editableByRowAction="selectedByAction"
						:isBlurAction="isBlurAction"
						:isHasSelected="isHasSelected"
						:pageSize="pageSize"
						:currentPage="currentPage"
					>
					</ms-tr-v-3>
				</tbody>

				<tbody v-else class="items-center flex justify-center">
					<tr class="ms-tr">
						<div class="flex justify-center">
							<div :class="noDataIconClass"></div>
						</div>
						<td class="items-center flex justify-center mt-2">
							{{ noDataText }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div
			v-if="showNotSupprtTaxOrther"
			class="not-support-tax-khac tax-not-support"
		>
			<div class="mi-new mi-24 mr-2 mi-warning-ava"></div>
			{{ $t('i18nInvoice.Service.NotSuggestTaxKHAC') }}
		</div>
		<ms-pagination
			v-if="pagination"
			:pageSize="pageSize"
			:dataRender="datax.length"
			:pageIndexCurrent="currentPage"
			:pageTotal="pageTotal"
			@loadData="listenersLoadData"
			:isLoadingTotalRecord="isLoadingTotalRecord"
			ref="paginationGrid"
		></ms-pagination>
	</div>
	<div
		class="ms-grid-viewer"
		:class="{ selectedTextMode: selectedTextMode }"
		v-else
		@keydown="keyDownGrid"
	>
		<div class="ms-content--header" ref="header">
			<table class="ms-table" ref="tableHeader">
				<thead class="ms-thead">
					<tr class="ms-tr">
						<th class="ms-th serial-title" v-if="serial">
							{{ $t('i18nCommon.OrderNumber') }}
						</th>
						<th v-if="multiple" class="ms-th multiple-cell">
							<ms-checkbox
								:checked="isCheckedMultiple"
								@click="changeCheckedMultiple"
								class="justify-center"
								checkOnly
							/>
						</th>
						<ms-th
							ref="th"
							class="ms-th"
							v-for="(col, colIndex) in columnx"
							:key="col.dataField"
							:col="col"
							:class="[
								columnx && colIndex == columnx.length - 1
									? 'ms-th-last-col'
									: '',
							]"
							@resizeOn="resizeActive"
							@resizeOff="resizeClose"
						></ms-th>
						<th
							class="ms-th widget-title"
							v-if="widgetOptions"
							:style="[
								{
									width: `${widgetOptions.width}px`,
									'min-width': `${widgetOptions.width}px`,
								},
							]"
						>
							<span>{{ widgetOptions.title }}</span>
						</th>
					</tr>
				</thead>
			</table>
		</div>
		<div class="ms-content--table">
			<msDynamicScroll
				:items="datax"
				:min-item-size="32"
				class="scroller"
				:style="gridViewStyle"
				keyField="__vKeyValue"
				:minWidth="widthx"
				@scroll="onScroll"
			>
				<template v-slot="{ item, index, active }">
					<msDynamicScrollerItem
						:item="item"
						:active="active"
						:data-index="index"
					>
						<table class="mw-full border-collapse">
							<ms-tr-v-3
								:key="item['__vKeyValue']"
								:ref="`tr-${index}`"
								:columns="columnx"
								:dataRow="item"
								:rowIndex="index"
								:isSelected="isSelected(item)"
								:widgetOptions="widgetOptions"
								:multiple="multiple"
								:serial="serial"
								v-on="listeners"
								:rowSelected="rowSelected"
								:editable="editable"
								:class="[
									{ 'row-editor': item == rowSelected },
									datax && index == datax.length - 1 ? 'ms-tr-last' : '',
								]"
								:isHoverTr="isHoverTr"
								:editableByRowAction="selectedByAction"
								:isBlurAction="isBlurAction"
								:isHasSelected="isHasSelected"
								:pageSize="pageSize"
								:currentPage="currentPage"
							></ms-tr-v-3>
						</table>
					</msDynamicScrollerItem>
				</template>
			</msDynamicScroll>
		</div>
		<ms-pagination
			v-if="pagination"
			:pageSize="pageSize"
			:dataRender="datax.length"
			:pageIndexCurrent="currentPage"
			:pageTotal="pageTotal"
			@loadData="listenersLoadData"
			:isLoadingTotalRecord="isLoadingTotalRecord"
			ref="paginationGrid"
		></ms-pagination>
	</div>
</template>
<script>
import msTrV3 from './msTrV3';
import msTh from './msTh';
import msPagination from '@/components/msgridviewerx/msPaginationViewer.vue';
import commonFunc from '@/common/commonFunction.js';
import msDynamicScroll from '@/components/msvirtualscroller/MsDynamicScroller.vue';
import msDynamicScrollerItem from '@/components/msvirtualscroller/MsDynamicScrollerItem.vue';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';

export default {
	name: 'msGridEditorV3',
	extends: msBaseComponent,
	components: {
		msTrV3,
		msTh,
		msPagination,
		msDynamicScroll,
		msDynamicScrollerItem,
	},
	props: {
		greyTitle: {
			default: false,
			type: Boolean,
		},
		//Value thực hiện lưu giá trị các cột được chọn
		value: {},
		//Data dữ liệu grid từ ngoài truyền vào
		data: {},
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 * @params columnType bao gồm các loại combobox,input,number,checkbox,datepicker,dropdown,template mặc định là input dùng để định nghĩa loại control editor
		 * @params editorProperty thông tin chuyền vào control editor thường có cấu trúc :
		 * editorProperty: {
							propsData: {
								(Dữ liệu truyền vào control)
							}
						}
			@params rules:"Trường dùng để validate trong grid các rule được phân cách nhau bởi ký hiệu | VD: required|email"
			@params template:Sử dụng 1 file khác ở ngoài truyền vào để render
		 */
		columns: {},
		/**
		 * Cấu hình cho cột chức năng là 1 đối tượng gồm có
		 * title: tên tiêu đề cột chức năng
		 * components:'components import vào'
		 * width:Độ rộng của cột
		 */
		widgetOptions: {},
		maxHeight: {
			default: null,
			type: [Number, String],
		},
		//Cấu hình có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
		queryMode: {
			default: 'remote',
			type: String,
		},
		//Cột cho phép tích chọn nhiều dòng
		multiple: {
			default: false,
			type: Boolean,
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		serial: {
			default: false,
			type: Boolean,
		},
		useVirtualScroll: {
			default: false,
			type: Boolean,
		},
		//Thuộc tính để cấu hình cho phép sửa trên grid hay không
		editable: {
			default: true,
			type: Boolean,
		},
		//Dữ liệu default
		defaultData: {
			default: null,
		},
		isHoverTr: {
			default: true,
			type: Boolean,
		},
		/**
		 * Có loading tổng số bản ghi hay không
		 */
		isLoadingTotalRecord: {
			default: false,
			type: Boolean,
		},
		selectedByAction: {
			default: false,
			type: Boolean,
		},
		actionClick: {
			default: true,
			type: Boolean,
		},
		keyTabAction: {
			default: true,
			type: Boolean,
		},
		keyShiftTabAction: {
			default: true,
			type: Boolean,
		},
		isBlurAction: {
			default: true,
			type: Boolean,
		},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		showNotSupprtTaxOrther: {
			default: false,
			type: Boolean,
		},
		/**
		 * Text hiển thị khi grid không có dữ liệu (mặc định dùng i18nCommon.noData)
		 */
		emptyDataText: {
			default: '',
			type: String,
		},
		/**
		 * Class icon hiển thị khi grid không có dữ liệu (mặc định icon image-no-pdf)
		 */
		emptyDataIconClass: {
			default: 'mi mi-new-v2 image-no-pdf',
			type: String,
		},
	},
	created() {
		const me = this;
		me.initColumns();
		me.initData();
		// if (!me.selectedByAction) {
		// 	document.addEventListener('mouseup', me.endEditor);
		// }
	},
	mounted() {
		if (this.$refs.tableHeader) {
			this.widthx = this.$refs.tableHeader.offsetWidth;
		}
	},
	computed: {
		/**
		 * Text hiển thị khi grid không có dữ liệu
		 * Ưu tiên cấu hình từ ngoài (emptyDataText), mặc định dùng i18nCommon.noData
		 */
		noDataText() {
			const me = this;
			return me.emptyDataText || me.$t('i18nCommon.noData');
		},
		/**
		 * Class icon hiển thị khi grid không có dữ liệu
		 * Ưu tiên cấu hình từ ngoài (emptyDataIconClass), mặc định icon image-no-pdf
		 */
		noDataIconClass() {
			const me = this;
			return me.emptyDataIconClass;
		},
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		listeners() {
			const me = this;
			return {
				click: (metaData) => {
					if (
						metaData.dataRow &&
						(metaData.dataRow.isSelected ||
							metaData.rowSelected.rowIndex == metaData.rowIndex)
					) {
						me.cellSelected(metaData);
					}
				},
				// dblclick: (dataRow, event) => {
				// 	me.$emit('dblclick', dataRow, event);
				// },
				keydown: (dataRow, event) => {
					if (me.editorSelected) {
						me.cellSelected(me.editorSelected);
						me.editorSelected.validateComponent();
					}

					me.row_keydown(dataRow, event);
					// me.$emit('keydown', dataRow, event);
				},
				widgetEvent: (data, event) => {
					if (!data) {
						me.$emit('widgetEvent', data, event);
						return;
					}
					let command = data.command;
					let dataRow = data.dataRow;
					let callbackFunc = null;
					switch (command) {
						case me.$ms.enum.Event.Edit:
							me.cellSelected(data.editor);
							break;
						case me.$ms.enum.Event.Save:
							if (me.editorSelectedCellError) return;
							callbackFunc = () => {
								me.endEditor();
							};
							break;
						case me.$ms.enum.Event.Cancel:
							if (me.editorSelectedCellError) {
								me.editorSelected.setValid();
							}
							callbackFunc = () => {
								me.endEditor();
							};
							break;
					}
					delete data.editor;
					data.callbackFunc = callbackFunc;
					me.$emit('widgetEvent', data, event);
				},
				// selected: (metaData) => {
				// 	me.$emit('selected', metaData);
				// },
				change: (metaData) => {
					me.beforeChange(metaData);
					me.$emit('change', metaData);
					// metaData.editor.validateComponent();
				},
				// rowSelected: (data) => {
				// 	me.updateRowSelected(data);
				// 	me.$emit('rowSelected', data);
				// },
				// loadDataCombo: (metaData) => {
				// 	me.$emit('loadDataCombo', metaData);
				// },
				blur: (metaData) => {
					// me.cellSelected(metaData.cell);
				},
				// next: () => {
				// 	me.next();
				// },
			};
		},
		scrollVisiable() {
			if (this.hasScroll) {
				return true;
			}
			return false;
		},
		/**
		 * Kiểm tra xem tất cả dữ liệu có đang được check hay không
		 * created by LTDAT 25.06.2020
		 */
		isCheckedMultiple() {
			if (this.value) {
				if (this.datax.length != 0) {
					return (
						this.value.length >= this.datax.length &&
						this.datax.every((item, index) => {
							return this.value.includes(item);
						})
					);
				} else {
					return false;
				}
			}
		},
		gridViewStyle() {
			if (this.maxHeight) {
				if (this.showNotSupprtTaxOrther) {
					return {
						'max-height': this.maxHeight,
					};
				}
				return {
					'max-height': this.maxHeight,
				};
			}
			return null;
		},
		isHasSelected() {
			const me = this;
			let checkExistSelect = me.datax.find((x) => x.isSelected);
			if (checkExistSelect) return true;
			return false;
		},
		editorSelectedCellError() {
			const me = this;
			let editorSelectedCellError =
				me.editorSelected &&
				me.editorSelected.cellErrorProvider &&
				Object.keys(me.editorSelected.cellErrorProvider).length > 0;
			if (!editorSelectedCellError && me.editorSelected) {
				me.editorSelected.validateComponent();
				editorSelectedCellError =
					me.editorSelected &&
					me.editorSelected.cellErrorProvider &&
					Object.keys(me.editorSelected.cellErrorProvider).length > 0;
			}
			return editorSelectedCellError;
		},
		calculateWidthGroup() {
			return (col, index, listColumns) => {
				const me = this;
				let widths = 0;
				col.lstColumn.forEach((x) => {
					widths += x.width ? x.width : 0;
				});
				if (index == 0) {
					me.lst1Widths = widths;
					return {
						width: widths + 60 + 'px',
						backgroundColor: col.backgroundColor,
						'min-width': `${widths + 60}px`,
					};
				} else {
					return {
						width: `calc(100% - ${me.lst1Widths}px - 60px)`,
						backgroundColor: col.backgroundColor,
						position: 'relative',
					};
				}
			};
		},
	},
	watch: {
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				this.checkHasScroll();
				if (newVal && me.datax != me.data) {
					me.initData(newVal);
				}
			},
		},
		pageTotal: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.currentPage = 1;
			},
		},
	},
	updated() {
		if (this.$refs.tableHeader) {
			this.widthx = this.$refs.tableHeader.offsetWidth;
		}
		if (this.datax != null && this.datax.length == 0 && this.defaultData) {
			this.datax.append(this.defaultData);
		}
		this.checkHasScroll();
	},
	methods: {
		beforeChange(metaData) {
			const me = this;
			let col = metaData.column,
				cell = metaData.cell;
			if (col) {
				let key = col.keyFromDate || col.keyToDate;
				if (key) {
					let colIndex = me.columnx.findIndex((_col) => {
						return _col.dataField == key;
					});
					let editor = me.findEditorByIndex(cell.rowIndex, colIndex);
					if (editor) {
						editor.cellErrorProvider = {};
					}
				}
			}
		},
		getCompareDataChange(dataDefault, isDefault = true) {
			const me = this;
			let ret = [];
			if (dataDefault)
				me.datax.forEach((data) => {
					let check = false;
					for (let i = 0; i < me.columnx.length; i++) {
						let col = me.columnx[i];
						if (data[col.dataField] || dataDefault[col.dataField]) {
							if (data[col.dataField] != dataDefault[col.dataField]) {
								check = true;
								break;
							}
						}
					}
					if (check == true) {
						ret.push(data);
					}
				});
			if (ret.length == 0 && isDefault) {
				ret.push(me.datax[0]);
			}
			return ret;
		},
		//Kiểm tra xem grid có scroll hay không?
		checkHasScroll() {
			if (this.$refs.content) {
				if (
					this.$refs.content.getBoundingClientRect().height + 2 <
					this.$refs.content.scrollHeight
				) {
					this.hasScroll = true;
				} else {
					this.hasScroll = false;
				}
			}
		},
		//Cập nhật lại row được chọn để css
		updateRowSelected(data) {
			const me = this;
			me.rowSelected = data;
		},
		updateSelectedAction(data) {
			const me = this;
			if (!me.isHoverTr) {
				me.rowSelected['isSelected'] = true;
			}
		},

		//Kết thúc edit khi ấn ra ngoài grid
		endEditor(e) {
			const me = this;
			// if (
			// 	!e.target.closest('.ms-grid-viewer') &&
			// 	!e.target.closest('.ms-dropdown')
			// ) {
			if (me.newEditor) {
				me.newEditor.isSelected = false;
			}
			me.rowSelected = null;
			me.editorSelected = null;
			// }
		},
		//Lấy độ rộng của table theo header
		//Created by LTDAT 01.07.2020
		tableResize() {},
		/**
		 * Sự kiện scroll trên grid
		 * Thay đổi lại tọa độ scroll trên header
		 * Created by LTDAT(25.06.2020)
		 */
		onScroll(e) {
			const me = this;
			if (e && me.$refs.header) {
				// Chưa hiểu đoạn này cẩn hiểu thêm
				me.$refs.header.scrollLeft = e.target.scrollLeft;
				// me.$refs.msThead.scrollLeft = e.target.scrollLeft;
				// me.$refs.msTheadV3.scrollLeft = e.target.scrollLeft;
			}
		},
		/**
		 * Kiểm tra xem cột được check hay không ?
		 * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
		 * @param dataRow dữ liệu của dòng được check
		 * Created by LTDAT 24.06.2020
		 *  */
		isSelected(dataRow) {
			const me = this;
			if (me.value && me.value.length > 0) {
				return me.value.includes(dataRow);
			}
			return false;
		},
		//Sự kiện ấn vào nút chọn tất cả bên trên header
		changeCheckedMultiple() {
			const me = this;
			if (me.isCheckedMultiple) {
				me.$emit('input', []);
			} else {
				me.$emit('input', me.datax);
			}
		},
		//Sự kiện chọn cell
		/**
		 * @params:editor control chứa edtior
		 */
		cellSelected(editor) {
			const me = this;
			me.oldEditor = me.newEditor;
			me.newEditor = editor;
			if (
				me.oldEditor &&
				me.oldEditor != me.newEditor &&
				me.oldEditor.dataRow.rowIndex != me.newEditor.dataRow.rowIndex
			) {
				me.oldEditor.isSelected = false;
			}
			if (
				me.newEditor &&
				me.newEditor.isSelected == false &&
				typeof me.newEditor.cellSelected == 'function'
			) {
				me.newEditor.cellSelected();
			}
			if (me.editable) {
				me.rowSelected = me.newEditor.dataRow;
			}

			me.editorSelected = me.newEditor;
			me.$emit('cellSelected', me.rowSelected);
		},
		//Tìm cell theo index
		/**
		 * @params rowIndex:vị trí Dòng
		 * @params colIndex:ví trí Cột
		 */
		findEditorByIndex(rowIndex, colIndex) {
			const me = this;
			if (!me.$refs) return;
			let row = me.$refs[`tr-${rowIndex}`];
			if (!row) return;
			let editor = null;
			if (Array.isArray(row)) {
				row = row[0];
			}
			if (row.$refs[`editor-${colIndex}`]) {
				editor = row.$refs[`editor-${colIndex}`][0];
			}
			return editor;
		},
		//Lấy dữ liệu của 1 trang khi phân trang local
		getItemPagination() {
			let me = this,
				pageSize = me.pageSize
					? me.pageSize
					: me.$ms.commonFunc.getTakePageSize(),
				min = Math.ceil((me.currentPage - 1) * pageSize),
				max = min + pageSize;
			let dataPagination = me.internalDataSource.filter((item, index) => {
				return index >= min && index < max;
			});
			return dataPagination;
		},
		//Xử lý sự kiện resize col trên grid
		//created by LTDAT(29.05.2020)
		resizeActive() {
			//Không cho phép bôi đen text
			this.selectedTextMode = true;
			if (this.$refs.th) {
				let listTh = this.$refs.th;
				listTh.forEach((item) => {
					item.updateColWidth();
					if (item == listTh[listTh.length - 1]) {
						item.autoResizex = true;
					}
				});
			}
		},
		//Đóng sự kiện resize cột trên grid
		//created by LTDAT(29.05.2020)

		resizeClose() {
			//Cho phép bôi đên text
			this.selectedTextMode = false;
		},
		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			// Case này dành cho trường hợp group
			me.listGroupColumns = columns;
			let listArray = [];
			columns.forEach((x) => {
				x.lstColumn.forEach((y) => {
					if (x.backgroundColor) {
						y.backgroundColor = x.backgroundColor;
					}
					listArray.push(y);
				});
			});
			me.columnx = listArray ? listArray : me.columns;
			me.setDefaultFieldColumn(me.columnx);
			if (!me.columnx) {
				me.columnx = [];
			}
			me.columnx = me.getVisiableColumn(me.columnx);
			let hasFlex = me.columnx.some((item) => {
				return item.autoResize;
			});
			if (hasFlex == false && me.columnx.length > 0) {
				me.$set(me.columnx[me.columnx.length - 1], 'autoResize', true);
			}
		},
		/** Lấy ra các column có thuộc tính visiable = true
		 * Created by LTDAT 17.07.2020
		 * */
		getVisiableColumn(columns) {
			return columns.filter((item) => {
				return item.visiable == true;
			});
		},
		/**
		 * Set giá trị default cho cấu hình cột
		 * Created by LTDAT(17.07.2020)
		 */
		setDefaultFieldColumn(columns) {
			//Nếu không cấu hình field hiện thị thì mặc định là true
			const me = this;
			columns.forEach((item) => {
				if (item.visiable != false) {
					item.visiable = true;
				}
				if (item.formatType == me.$ms.enum.FormatType.Number) {
					item.align = 'right';
				} else if (
					item.formatType == me.$ms.enum.FormatType.Date ||
					item.formatType == me.$ms.enum.FormatType.DateTime
				) {
					item.align = 'center';
				}
			});
		},
		//Xóa 1 phần tử trong data grid
		removeItem(item) {
			const me = this;
			me.datax = _.remove(me.datax, (e) => {
				return e !== item;
			});
		},
		//Gán giá trị để render data có thể truyền từ ngoài vào
		initData(data = this.data) {
			const me = this;
			let dataSource = null;
			if (data) {
				dataSource = data;
			}
			//Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
			if (me.queryMode == 'local' && me.pagination) {
				me.internalDataSource = dataSource;
				commonFunc.genVKeyValue(me.internalDataSource);
				me.datax = me.getItemPagination();
			}
			//Lấy dữ liệu từ server
			else {
				//Tạm gán = props data sau gán = gì khác tính sau
				me.datax = dataSource;
				commonFunc.genVKeyValue(me.datax);
			}
			// me.$nextTick(() => {
			// 	this.checkHasScroll();
			// });
		},
		//Lấy dữ liệu của dòng được chọn
		getRowSelected() {
			const me = this;
			return me.rowSelected;
		},
		//Xử lý sự kiện ấn phím trên row
		//Created by LTDAT(15.06.2020)
		row_keydown(dataRow, e) {
			const me = this;
			switch (e.which) {
				case 9: //Tab
					{
						if (!me.keyTabAction) return;
						if (e.shiftKey) {
							me.pre();
						} else {
							me.next();
						}
					}
					break;
				case 13: //Enter
					me.next();
					break;
			}
		},
		/**
		 * Hàm validate cho trên data của grid
		 */
		validate() {
			const me = this;
			let listRules = [],
				rulesValidate = null,
				errorList = [],
				ret = false;
			me.datax.forEach((_data, _indexData) => {
				if (!_data._isTemp) {
					// if (
					// 	!me.$ms.commonFunc.objectHasDataEmpty(_data, ['__vKeyValue']) ||
					// 	_indexData == 0
					// ) {
					me.columnx.forEach((_col, _indexCol) => {
						let rules = _col.rules;

						if (_col.keyFromDate || _col.keyToDate) {
							let message = null,
								fromDate = null,
								toDate = null;
							if (_col.keyFromDate) {
								message =
									_col.title +
									` ${me.$t('i18nCommon.conditionmaxorequal')} ` +
									_col.keyTitleFromDate;
								fromDate = _data[_col.keyFromDate];
								toDate = _data[_col.dataField];
							} else {
								message =
									_col.title +
									` ${me.$t('i18nCommon.conditionminorequal')} ` +
									_col.keyTitleToDate;
								fromDate = _data[_col.dataField];
								toDate = _data[_col.keyToDate];
							}
							if (fromDate && toDate) {
								let startDate = new Date(fromDate);
								let endDate = new Date(toDate);
								startDate.setHours(0, 0, 0);
								endDate.setHours(23, 59, 59);
								ret = !me.validateDateRange(startDate, endDate);
								if (ret) {
									me.setValid(
										_col,
										_indexData,
										_indexCol,
										rulesValidate,
										errorList,
										message
									);
								}
							}
						}
						// Check valid theo cột dữ liệu trên dòng
						if (_col.validBy) {
							let status = _data[_col.validBy];
							if (!status) {
								return;
							}
						}
						if (_col.rules && typeof _col.rules == 'function') {
							rules = _col.rules(_data);
						}
						if (rules) {
							listRules = rules.split('|');
							for (let i = 0; i < listRules.length; i++) {
								ret = !me.validateRule(
									listRules[i],
									_data[_col.dataField],
									_col.__editor
								);
								if (ret) {
									rulesValidate = listRules[i];
									break;
								}
							}
							if (ret) {
								me.setValid(
									_col,
									_indexData,
									_indexCol,
									rulesValidate,
									errorList
								);
							}
						}
					});
					// }
				}
			});
			return errorList;
		},

		setValid(_col, _indexData, _indexCol, rulesValidate, errorList, message) {
			const me = this;
			let errorProvider = {};
			if (message) {
				errorProvider.message = message;
			} else if (me.$t('i18nValidate').messages[rulesValidate]) {
				errorProvider.message = me
					.$t('i18nValidate')
					.messages[rulesValidate](_col.title);
			}
			errorProvider.rules = rulesValidate;
			errorProvider.element = me.findEditorByIndex(_indexData, _indexCol);
			if (!errorProvider.element.readOnly) {
				me.$set(errorProvider, 'isValid', true);
			}
			errorProvider.gridIns = me;
			errorProvider.element.cellErrorProvider = errorProvider;
			errorList.push(errorProvider);
		},

		focusLastControl(event) {
			const me = this;
			if (me.newEditor && me.newEditor.isSelected) {
				me.newEditor.isSelected = false;
				me.$ms.commonFunc.focusNextControl(event.target);
			} else {
				let row = me.datax.length - 1,
					preEdit;
				me.$nextTick(() => {
					for (let i = me.columnx.length; i > 0; i--) {
						preEdit = me.findEditorByIndex(row, i - 1);
						if (preEdit && !preEdit.readOnly) {
							break;
						}
					}
					if (preEdit) {
						me.cellSelected(preEdit);
					}
				});
			}
		},
		//focus vào editor đầu tiên trong grid
		focusFisrtControl() {
			const me = this;
			let row = 0,
				col = -1,
				nextEdit;
			me.$nextTick(() => {
				for (let i = col; i < me.columnx.length; i++) {
					nextEdit = me.findEditorByIndex(row, i + 1);
					if (nextEdit && !nextEdit.readOnly) {
						break;
					}
				}
				if (nextEdit) {
					me.cellSelected(nextEdit);
				}
			});
		},
		//Focus vào editor đầu tiên ở dòng cuối cùng
		focusLastRow() {
			const me = this;
			let row = me.datax.length - 1,
				col = -1,
				nextEdit;
			me.$nextTick(() => {
				for (let i = col; i < me.columnx.length; i++) {
					nextEdit = me.findEditorByIndex(row, i + 1);
					if (nextEdit && !nextEdit.readOnly) {
						break;
					}
				}
				if (nextEdit) {
					me.cellSelected(nextEdit);
				}
			});
		},

		focusRowByIndex(rowIndex) {
			const me = this;
			let row = me.datax.length - 1,
				col = -1,
				nextEdit;
			me.$nextTick(() => {
				for (let i = col; i < me.columnx.length; i++) {
					nextEdit = me.findEditorByIndex(rowIndex, i + 1);
					if (nextEdit && !nextEdit.readOnly) {
						break;
					}
				}
				if (nextEdit) {
					me.cellSelected(nextEdit);
				}
			});
		},
		//Chuyển editor sang ô tiếp theo
		next() {
			const me = this;
			if (me.newEditor) {
				let row = me.newEditor.rowIndex,
					col = me.newEditor.colIndex,
					nextEdit;
				for (let i = col; i < me.columnx.length; i++) {
					nextEdit = me.findEditorByIndex(row, i + 1);
					if (nextEdit && !nextEdit.readOnly) {
						break;
					}
				}
				if (nextEdit && col <= me.columnx.length - 1) {
					me.cellSelected(nextEdit);
				}
				// else {
				// 	//Trường hợp là dòng cuối cùng
				// 	if (row == me.datax.length - 1) {
				// 		// me.newEditor.isSelected = false;
				// 		return;
				// 	} else {
				// 		for (let i = 0; i < me.columnx.length; i++) {
				// 			nextEdit = me.findEditorByIndex(row + 1, i);
				// 			if (nextEdit && !nextEdit.readOnly) {
				// 				break;
				// 			}
				// 		}
				// 		me.cellSelected(nextEdit);
				// 	}
				// }
			}
		},
		//Di chuyển editor và trước
		pre() {
			const me = this;
			if (me.newEditor) {
				let row = me.newEditor.rowIndex,
					col = me.newEditor.colIndex,
					preEdit;
				for (let i = col; i >= 0; i--) {
					preEdit = me.findEditorByIndex(row, i - 1);
					if (preEdit && !preEdit.readOnly) {
						break;
					}
				}
				if (preEdit) {
					me.cellSelected(preEdit);
				} else {
					//Trường hợp là dòng cuối cùng
					if (row == 0) {
						return;
					} else {
						for (let i = me.columnx.length - 1; i >= 0; i--) {
							preEdit = me.findEditorByIndex(row - 1, i);
							if (preEdit && !preEdit.readOnly) {
								break;
							}
						}
						me.cellSelected(preEdit);
					}
				}
			}
		},
		//Created by LTDAT(27.07.2020)
		listenersLoadData(payload) {
			const me = this;
			if (me.pagination) {
				me.currentPage = payload.skip / payload.take + 1;
				me.pageSize = payload.take;
			}
			me.$emit('loadData', payload);
		},
		cellClick(data) {
			const me = this;
		},
		keyDownGrid(e) {
			const me = this;
			if (e.key == 'Tab') {
				e.preventDefault();
			}
		},
		beforeSaveWidget() {},

		beforeCancelWidget() {},

		loadPageIndexGrid(index, callback) {
			const me = this;
			if (me.$refs && me.$refs.paginationGrid) {
				me.$refs.paginationGrid.loadPageInfoIndex(index);
				let pageSize = me.$refs.paginationGrid.pageSize;
				let payload = {
					skip: (index - 1) * pageSize,
					take: pageSize,
				};

				me.currentPage = index;
				me.pageSize = pageSize;
				me.$emit('loadPageIndexGrid', { payload: payload, callback: callback });
			}
		},
	},
	data() {
		const me = this;
		return {
			//Lưu dữ liệu các dòng trong grid
			datax: null,
			//Lưu dữ liệu cấu hình cột trong grid
			columnx: null,
			//Cho sao chép/bôi đen dữ liệu hay không
			selectedTextMode: false,
			//Trang hiện tại
			currentPage: 1,
			//Dòng được chọn
			rowSelected: {},
			editorSelected: null,
			//Độ rộng của table
			widthx: 0,
			hasScroll: false,
			pageSize: me.$ms.commonFunc.getTakePageSize(),
			isEditRow: false,
			listGroupColumns: [],
			lst1Widths: 0,
		};
	},
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
.no-data {
	text-align: center;
	// font-size: 16px;
	padding: 10px 0;
}

.tax-not-support {
	position: sticky;
	background-color: $ms-color-status-warning-secondary;
	width: 100%;
	display: flex;
	align-items: center;
	height: 48px;
	z-index: 100;
	justify-content: center;
	bottom: 48px;
}
</style>